import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { useLanguage } from '../lib/i18n';
export function HeroSection() {
  const {
    t
  } = useLanguage();
  const handleScrollToVehicles = () => {
    const element = document.querySelector('#vozy');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative h-screen w-full overflow-hidden" data-id="element-98">
      {/* Background Image */}
      <div className="absolute inset-0" data-id="element-99">
        <img src="https://cdn.magicpatterns.com/uploads/vn9rRc6M6MNZxeCHNrDR1A/IMG_9098.jpg" alt="Porsche 911 Carrera GTS" className="w-full h-full object-cover" style={{
        objectPosition: 'center 35%'
      }} data-id="element-100" />
        {/* Gradient Overlays */}
        <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-[#0a0a0a]/60 to-transparent" data-id="element-101" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0a0a0a]/80 via-transparent to-transparent" data-id="element-102" />
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col justify-end pb-24 md:pb-32 px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-103">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="max-w-3xl" data-id="element-104">
          <motion.h1 initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.5
        }} className="text-4xl md:text-5xl lg:text-7xl font-bold text-white leading-tight mb-6" data-id="element-105">
            {t('hero.headline1')}
            <br data-id="element-106" />
            <span className="text-[#c8a96e]" data-id="element-107">{t('hero.headline2')}</span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.7
        }} className="text-lg md:text-xl text-[#a3a3a3] mb-10 max-w-xl leading-relaxed" data-id="element-108">
            {t('hero.subtitle')}
          </motion.p>

          <motion.button initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.9
        }} onClick={handleScrollToVehicles} className="group inline-flex items-center gap-3 bg-[#c8a96e] hover:bg-[#d4b87a] text-[#0a0a0a] px-8 py-4 text-base font-semibold tracking-wide transition-all duration-300" data-id="element-109">
            {t('hero.cta')}
            <ChevronDownIcon className="w-5 h-5 group-hover:translate-y-1 transition-transform" data-id="element-110" />
          </motion.button>
        </motion.div>

        {/* Scroll Indicator */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 1.2
      }} className="absolute bottom-8 left-1/2 -translate-x-1/2 hidden md:block" data-id="element-111">
          <motion.div animate={{
          y: [0, 8, 0]
        }} transition={{
          duration: 1.5,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="w-6 h-10 border-2 border-[#a3a3a3]/50 rounded-full flex justify-center pt-2" data-id="element-112">
            <div className="w-1.5 h-3 bg-[#c8a96e] rounded-full" data-id="element-113" />
          </motion.div>
        </motion.div>
      </div>
    </section>;
}